<template>
    <div class="sales-filters">
        <v-row>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                        v-model="activeFilters.category"
                        clearable
                        :label="categories.label"
                        :items="categories.valuesData"
                        hide-no-data
                        item-text="name"
                        item-value="id"
                        @change="filterChange"
                        cache-items
                        color="orange lighten-2"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                        v-model="activeFilters.product"
                        clearable
                        :label="products.label"
                        :items="products.valuesData"
                        hide-no-data
                        item-text="name"
                        item-value="id"
                        @change="filterChange"
                        cache-items
                        color="orange lighten-2"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-center">
                <v-autocomplete
                        v-model="activeFilters.article"
                        clearable
                        :label="articles.label"
                        :items="articles.valuesData"
                        hide-no-data
                        item-text="name"
                        item-value="id"
                        @change="filterChange"
                        cache-items
                        color="orange lighten-2"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import FiltersGeneral from '../../../app-front/mixins/FiltersGeneral';
    import FilterService from '../../services/api/FilterService';

    export default {
        name: "ProfileProductsFilters",
        mixins:[FiltersGeneral],
        data(){
            return {
                activeFilters: {},
                buyerSearch: null,
                layout:[]
            }
        },
        computed: {
            articles() {
                const filter = this.layout.find(item => item.systemName === this.filtersGeneral.article.systemName);

                return filter || {};
            },
            categories() {
                const filter = this.layout.find(item => item.systemName === this.filtersGeneral.category.systemName);

                return filter || {};
            },
            products() {
                const filter = this.layout.find(item => item.systemName === this.filtersGeneral.product.systemName);

                return filter || {};
            }
        },
        methods: {
            getLayout() {
                FilterService.setLocale(this.$store.state.language.appLanguage);
                FilterService.getProfileProductsLayout()
                    .then(res => {
                        this.layout = res.data;
                        this.setFiltersFromUrl();
                    })
                    .catch(err => {console.log(err)});
            },
            filterChange(){
                this.addFiltersToUrl(this.activeFilters, this.$route);
                this.$emit('filter-change', this.activeFilters);
            },
            setFiltersFromUrl(){
                this.activeFilters = this.getFiltersFromUrl();
                this.filterChange();
            }
        },
        created() {
            this.getLayout();
        },
    }
</script>

<style scoped>

</style>
